import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Benefits from '../components/Benefits';
import Transformation from '../components/Transformation';
import Pricing from '../components/Pricing';
import CTA from '../components/CTA';
import Footer from '../components/Footer';
import { shouldShowPricing } from '../utils/domainConfig';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Hero />
      <Features />
      <Benefits />
      <Transformation />
      {shouldShowPricing() && <Pricing />}
      <CTA />
      <Footer />
    </div>
  );
};

export default LandingPage;
